import React from 'react';
import Background from './components/Background/Background';
import NavBar from "./components/NavBar/NavBar";
import About from "./components/About/About";
import styles from './App.module.css';
import Marquee from "react-fast-marquee";
import Skills from "./components/Skills/Skills";
import Projects from "./components/Projects/Projects";
import Footer from "./components/Footer/Footer";
import Contacts from "./components/Contacts/Contacts";
import {useState, useEffect} from "react";

function App() {
    const imgPaths = [
        {name: "c++", src: `${process.env.PUBLIC_URL}/cplus-icon.png`},
        {name: "c#", src: `${process.env.PUBLIC_URL}/csharp-icon.png`},
        {name: "qt", src: `${process.env.PUBLIC_URL}/qt-icon.png`},
        {name: "css", src: `${process.env.PUBLIC_URL}/css-icon.png`},
        {name: "html", src: `${process.env.PUBLIC_URL}/html-icon.png`},
        {name: "js", src: `${process.env.PUBLIC_URL}/js-icon.png`},
        {name: "react", src: `${process.env.PUBLIC_URL}/react-icon.png`},
        {name: "node", src: `${process.env.PUBLIC_URL}/node-icon.png`},
    ]
    const [isMobile, setIsMobile] = useState(false);
    const [theme, setTheme] = useState("dark-theme");

    useEffect(() => {
        document.documentElement.classList.remove(...document.documentElement.classList);
        document.documentElement.classList.add(theme);
    }, [theme]);

    useEffect(() => {
        const hanldeResize = () =>{
            if(window.innerWidth < 992) setIsMobile(true);
            else setIsMobile(false);
        }
        hanldeResize();
        window.addEventListener("resize", hanldeResize);
        return () => window.removeEventListener("resize", hanldeResize);
    }, [])

    return (
        <div className={styles.app}>
            <a href="#main-content" className={styles.skipLink}>
                Перейти к основному содержимому
            </a>
            <NavBar isMobile={isMobile} setTheme={setTheme}/>
            <About/>
            <Skills />
            <div className={styles.container}>
                <Marquee
                    speed={70}
                    gradient={false}
                    className={styles.marquee}
                >
                    {imgPaths.map(imgPath => (
                        <img
                            key={imgPath.name}
                            className={styles.icon}
                            src={imgPath.src}
                            alt={imgPath.name}
                        />
                    ))}
                </Marquee>
            </div>
            <Projects />
            <Contacts/>
            <Footer />
            <Background theme={theme}/>
        </div>
    );
}

export default App;
